module.exports = __webpack_public_path__ + "img/traffic-light-orange.1fa980a1.svg";